export default __webpack_public_path__ + "static/media/icon-information.f0eed270.svg";